/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-progress-wheel/ag-grid-evrideo-progress-wheel.component.scss */
svg {
  transform: rotate(-90deg);
}
/*# sourceMappingURL=ag-grid-evrideo-progress-wheel.component.css.map */
